module.exports = __webpack_public_path__ + "static/img/kefu2.6a50138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/kefu2.jpg
// module id = HL01
// module chunks = 1